import PropTypes from 'prop-types';

// components
import { CmsComponentSwitch } from 'src/cms/CmsComponentSwitch';
import { ContentfulToolbar } from 'src/components/ContentfulToolbar';
import { Alert } from 'src/components/Feedback';
import { TemplateWrapper } from 'src/templates';

// helpers
import LegacyScripts from 'src/components/LegacyScripts';
import { CmsThemes, ContentfulTemplates } from 'src/lib/constants';
import { TemplateFieldShape } from 'src/lib/prop-types';

const propTypes = {
  fields: TemplateFieldShape.isRequired,
  locale: PropTypes.string,
};

const LandingPageTemplate = ({ fields, locale }) => {
  return (
    <TemplateWrapper
      meta-title={fields?.metaTitle}
      meta-description={fields?.metaDescription}
      hasFooterCta={fields?.hasFooterCta}
      noIndex={fields?.metaNoindex}
      locale={locale}
      cmsTheme={CmsThemes.WEB3}
    >
      <div data-testid={ContentfulTemplates.LANDING_PAGE}>
        {/* @TODO: TBD when to remove FinRise banner [redacted]############################# */}
        {fields.pageSlug === 'accelerate' && (
          <Alert
            ctaText='Read our blog post'
            href='/blog/accelerate/'
            target='_blank'
            title={false}
            success
          >
            We are excited to announce that Plaid FinRise is now{' '}
            <strong>Plaid Accelerate</strong>.
          </Alert>
        )}
        <CmsComponentSwitch components={fields?.components} />
      </div>
      <LegacyScripts />
      <ContentfulToolbar />
    </TemplateWrapper>
  );
};
LandingPageTemplate.propTypes = propTypes;

export default LandingPageTemplate;
